
import "@/assets/css/ozonpay-btn.css"
import {defineComponent} from 'vue'
import {paymentMethodsHelper} from "@/service/PaymentMethodsHelper";

export default defineComponent({
  emits: ['btn:click'],
  setup() {
    return {
      paymentMethodsHelper
    }
  }
})
